import React, {useEffect} from "react";
import {useSetState} from "ahooks";
import {Col, Row} from "antd";
import {SListTabs} from "shj-components";
import {getClueDetail} from "@/services/saleOpServices.ts";

import UserInfoModule from "./Right/UserInfoModule";
import FollowUpDiary from "./Right/FollowUpDiary";
import {Left} from "./Left";
import ClueDetailContext from "./clueDetailContext.ts";
import {ClueInfoAddOper} from "@/pages/callTool/intelligentOutboundCall/components/Info/Right/ClueInfoAddOper";
import {useAtom} from "jotai";
import {callListAtom} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";

export const CallModal = (props) => {
  const [callList] = useAtom(callListAtom)
  const [state, setState] = useSetState<any>({
    detailInfo: {},
    clueId: props.clueId,
    loading: false,
    isFreePhone: false,
  })

  const updatePhone = (phone) => {
    setState({isFreePhone: phone !== state.detailInfo.phone})
  }

  useEffect(() => {
    if (props.clueId) {
      setState({clueId: props.clueId})
      getInfo()
    }
  }, [props.clueId, callList.reload]);

  const getInfo = () => {
    setState({loading: true})
    getClueDetail(props.clueId).then(res => {
      setState({detailInfo: res, loading: false})
    })
  }

  const tabs = [
    {
      key: 'followUpDiary',
      label: '跟进日志',
      children: (
          <FollowUpDiary/>
      )
    },
    {
      key: 'userInfo',
      label: '客户信息',
      children: (
          <UserInfoModule/>
      )
    },
  ]

  return <ClueDetailContext.Provider value={{...state, updatePhone}}>
    <Row gutter={1} style={{backgroundColor: '#f6f8fb', height: '100%'}} wrap={false}>
      {/* 通话信息 */}
      <Col flex='320px'>
        <Left/>
      </Col>
      {/* 客户、跟进信息 */}
      <Col flex={"auto"}>
        <ClueInfoAddOper/>
        <SListTabs auth={false} items={tabs}/>
      </Col>
    </Row>
  </ClueDetailContext.Provider>
}